import videojs from 'expose-loader?videojs!video.js/dist/video.min.js';
import 'imports-loader?define=>false!videojs-resolution-switcher/lib/videojs-resolution-switcher';
import 'imports-loader?define=>false!videojs-vjsdownload/dist/videojs-vjsdownload.min';
import 'imports-loader?define=>false!./videojs-moviemode-plugin';

import "./videojs.sass";

(function($, window, undefined_) {


  $( document ).ready(function() {
    if ($('.video-js-player').length > 0) {
      $('.video-js-player').iversityVideo();
    }
  })

  var defaults, pluginName;
  var IversityVideo = function(el, options) {
    var $main_element, base, is_playing, is_seeking, parent_id, seek_end, seek_start;
    base = this;
    $main_element = $(el);
    seek_start = 0;
    seek_end = 0;
    is_seeking = false;
    is_playing = false;
    parent_id = false;
    base.$user_data = $main_element.closest('.js-video-userdata');
    base.paused_at = base.$user_data.data('paused-at');

    base.init = function() {
      $main_element.on("destroy", function() {
        return base.destroy();
      });
      base.options = $.extend({}, defaults, options);
      return base.delegateEvents();
    };

    base.destroy = function() {
      $main_element.unbind("plugin_" + pluginName);
      return $main_element.removeData("plugin_" + pluginName);
    };

    base.recacheElements = function(el) {};

    base.delegateEvents = function() {
      var plugins;
      base.registerEvent("lesson_unit_view");
      plugins = {
        movieMode: {},
        videoJsResolutionSwitcher: {
          "default": '720',
          dynamicLabel: true
        }
      };

      if ($main_element.attr('downloadable') === 'true') {
        plugins['vjsdownload'] = {
          beforeElement: 'playbackRateMenuButton',
          textControl: 'Download video',
          name: 'downloadButton'
        };
      } else if ( $main_element.attr('downloadable') === 'false') {
        $main_element.on('contextmenu', function(e) {
          e.preventDefault();
        }, false);
      }

      return videojs($main_element.attr('id'), {
        "playbackRates": [0.5, 1, 1.5, 2],
        plugins: plugins
      }, function() {
        var height, myPlayer, to;

        myPlayer = this;

        // preset expected video frame height
        // height = base.VideoFrameHeight();
        // if (height !== void 0) {
        //   $main_element.closest('.video-wrapper').css('height', height);
        //   myPlayer.height(height);
        // }

        myPlayer.on("play", base.videoPlayEventListener);
        myPlayer.on("pause", base.videoPauseEventListener);
        myPlayer.textTracks().on("change", base.videoSubtitleChangedEventListener);
        myPlayer.on("ended", base.videoEnded);
        myPlayer.on("fullscreenchange", base.videoFullscreenChange);
        myPlayer.on("ratechange", base.videoRateChanged);
        myPlayer.on("timeupdate", base.videoTimeUpdate);
        to = setTimeout((function() {
          if (($.cookie('subtitles') !== 'off' || typeof ($.cookie('subtitles')) === 'undefined') && myPlayer.textTracks().length > 0) {
            return $(myPlayer.textTracks()).each(function(i, t) {
              if (this.language === $.cookie('subtitles')) {
                this.mode = 'showing';
              }
            });
          }
        }), 3000);
        $(window).on( 'unload', function() {
          if (!myPlayer.paused()) {
            return base.registerEvent("video_stop", {
              video_second: myPlayer.currentTime()
            });
          }
        });
        $main_element.closest('.video-js').find('.vjs-big-play-button').on('click', function(e) {
          myPlayer = $($(this).parent('video-js')[0]).data('plugin_iversityVideo');
          return setTimeout((function() {
            var $video, query_seconds, time;
            time = 0;
            $video = $(myPlayer.el()).find('video');
            query_seconds = getQueryParams(window.location.search).s;
            if (query_seconds !== void 0) {
              query_seconds = parseInt(query_seconds);
              if (query_seconds < myPlayer.duration() && $video.closest('.unit-resource').length > 0) {
                time = query_seconds;
              }
            } else {
              if (myPlayer.duration() !== base.paused_at && base.paused_at !== '0') {
                time = parseInt(base.paused_at);
              } else {

              }
            }
            if (time !== 0 && time < myPlayer.duration() - 2) {
              myPlayer.currentTime(time);
              return base.registerEvent("video_resume", {
                video_second: time
              });
            }
          }), 1000);
        });

        /**
         * Add Keyboard events to video player
         * within a main unit resource
         */
        if ($('.unit-resource .video-js').length > 0) {
          $(window).on("keydown", function(e) {
            if ((e.target.nodeName !== 'TEXTAREA' && e.target.nodeName !== 'INPUT') && (e.charCode === 32 || e.keyCode === 32)) {
              return e.preventDefault();
            }
          });
          return $(window).on("keyup", function(e) {
            if (e.target.nodeName !== 'TEXTAREA' && e.target.nodeName !== 'INPUT') {
              return setTimeout((function() {
                var $unit_video;
                $unit_video = $('.unit-resource .video-js');
                if (e.charCode === 32 || e.keyCode === 32) {
                  e.preventDefault();
                  if ($unit_video.hasClass('vjs-paused')) {
                    $unit_video.find('video').trigger('play');
                  }
                  if ($unit_video.hasClass('vjs-playing')) {
                    $unit_video.find('video').trigger('pause');
                  }
                }
                if ((e.keyCode === 39 || e.charCode === 39) && $unit_video.hasClass('vjs-has-started')) {
                  $unit_video.find('video')[0].currentTime += 5;
                }
                if ((e.keyCode === 37 || e.charCode === 37) && $unit_video.hasClass('vjs-has-started')) {
                  return $unit_video.find('video')[0].currentTime -= 5;
                }
              }), 0);
            }
          });
        }
      });
    };
    base.registerEvent = function(event, data) {
      var is_async;
      is_async = (event === 'video_stop' ? false : true);
      data = {
        event: event,
        segment_id: $("#unit").data("id"),
        data: data
      };
      if (event !== 'lesson_unit_view') {
        data['unit_resource_id'] = $main_element.data("unitResourceId");
      }
      return $.ajax({
        type: "POST",
        async: is_async,
        url: "/registerevent",
        data: data,
        success: function(data) {}
      });
    };
    base.videoPlayEventListener = function(e) {
      var $video, myPlayer, time;
      e.preventDefault();
      is_playing = true;
      myPlayer = this;
      $video = $(myPlayer.el()).find('video');
      time = myPlayer.currentTime();
      base.registerEvent("video_play", {
        video_second: time,
        parent_id: is_seeking ? parent_id : void 0
      });
      return is_seeking = false;
    };
    base.videoPauseEventListener = function(e) {
      var $video, myPlayer;
      is_playing = false;
      myPlayer = this;
      $video = $(myPlayer.el()).find('video');
      base.$user_data.data('paused-at', myPlayer.currentTime());
      return base.registerEvent("video_pause", {
        video_second: is_seeking ? seek_start : myPlayer.currentTime(),
        parent_id: is_seeking ? parent_id : void 0
      });
    };
    base.videoSubtitleChangedEventListener = function(e) {
      var cookie_state, myPlayer;
      myPlayer = this.tracks_[0].tech_.player_;
      cookie_state = 'off';
      $(myPlayer.textTracks()).each(function() {
        if (this.mode === 'showing') {
          return cookie_state = this.language;
        }
      });
      return $.cookie('subtitles', cookie_state, {
        domain: cookieDomain(),
        expires: 60,
        path: '/'
      });
    };
    base.videoEnded = function(e) {
      var $video, myPlayer;
      myPlayer = this;
      $video = $(myPlayer.el()).find('video');
      base.$user_data.data('paused-at', 0);
      return base.registerEvent("video_ended", {
        video_second: myPlayer.currentTime()
      });
    };
    base.videoFullscreenChange = function(e) {
      var myPlayer;
      myPlayer = this;
      return base.registerEvent("video_fullscreen", {
        video_second: myPlayer.currentTime()
      });
    };
    base.videoRateChanged = function(e) {
      return base.registerEvent("video_rate", {
        video_second: e.target.playbackRate
      });
    };
    base.videoTimeUpdate = function(e) {
      var myPlayer, where_at;
      myPlayer = this;
      where_at = Math.round(myPlayer.currentTime());
      seek_start = seek_end;
      seek_end = where_at;
      if (Math.abs(seek_start - seek_end) > 1) {
        is_seeking = true;
        parent_id = new Date().getTime();
        base.registerEvent("video_seek_from", {
          video_second: seek_start,
          parent_id: parent_id
        });
        return base.registerEvent("video_seek_to", {
          video_second: seek_end,
          parent_id: parent_id
        });
      }
    };
    base.VideoFrameHeight = function() {
      if ($main_element.data('resolutionRatio') > 0 && $main_element.width() > 0) {
        return $main_element.width() * $main_element.data('resolutionRatio');
      } else {
        return void 0;
      }
    };
    return base.init();
  };
  "use strict";
  pluginName = "iversityVideo";
  defaults = {};
  return $.fn[pluginName] = function(options) {
    return this.each(function() {
      if (!$.data(this, "plugin_" + pluginName)) {
        return $.data(this, "plugin_" + pluginName, new IversityVideo(this, options));
      }
    });
  };
})(jQuery, window);